import {handleActions} from 'redux-actions';
import {RESET_LOADING, START_LOADING, FINISH_LOADING} from './LoadingActions';
import {LoadingState, LoadingPayload} from '../LoadingTypes';

const initialState = {
    loading: new Set<string>(),
    loaded: new Set<string>(),
};

export const deleteItem = (set: Set<string>, item: string) => {
    set.delete(item);
    return set;
};

export const resetLoading = (
    {loading, loaded}: LoadingState,
    {payload: tag}: LoadingPayload
) => ({
    loading: deleteItem(loading, tag),
    loaded: deleteItem(loaded, tag),
});

export const startLoading = (
    {loading, loaded}: LoadingState,
    {payload: tag}: LoadingPayload
) => ({
    loading: tag ? loading.add(tag) : loading,
    loaded: deleteItem(loaded, tag),
});

export const finishLoading = (
    {loading, loaded}: LoadingState,
    {payload: tag}: LoadingPayload
) => ({
    loading: deleteItem(loading, tag),
    loaded: tag ? loaded.add(tag) : loaded,
});

const handlers = {
    [RESET_LOADING]: resetLoading,
    [START_LOADING]: startLoading,
    [FINISH_LOADING]: finishLoading,
};

export default handleActions(handlers, initialState);
